/**
 * The recipe the Add Recipe sheet just wrote, handed to the detail screen in
 * memory (#791).
 *
 * « Ajouter manuellement » writes a blank document, then opens it at
 * `recipe-detail/<id>?draft=1`. The screen used to read it back before drawing
 * anything: up to four Firestore round trips in a row, behind « Chargement de
 * la recette… », for a document the phone had written a moment before. On
 * Safari a Firestore read can wait out the long-poll's 30 s window, and the
 * cook in #791 watched the spinner for 30.6 s. Nothing in a draft can have
 * changed since it was written, so the screen takes it from here instead.
 *
 * Used once. The screen releases it as soon as it has drawn it, so a later
 * visit to the same URL (forward, after a save) reads the stored recipe rather
 * than the blank. A reload finds nothing here and reads Firestore as before.
 */

import type { Recipe } from '../types/recipe';

const drafts = new Map<string, Recipe>();

export function handOffDraftRecipe(id: string, recipe: Recipe): void {
  drafts.set(id, recipe);
}

/** The draft written for `id`, if it has not been drawn yet. */
export function peekDraftRecipe(id: string): Recipe | null {
  return drafts.get(id) ?? null;
}

export function releaseDraftRecipe(id: string): void {
  drafts.delete(id);
}
